import React from 'react';
import { ReactComponent as ExclamationIcon } from '@blink/assets/src/icons/exclamation.svg';

import { TooltipWrapper } from '@/shared/ui';

export const InfoCardTooltip = () => {
    return (
        <TooltipWrapper
            text='Ensure you have sufficient collateral to maintain a low-risk factor and avoid
            liquidation. Adding more collateral will reduce your risk and keep your position in a
            safe zone'
            icon={<ExclamationIcon />}
        />
    );
};
